import React, {useEffect} from "react";
import cn from "classnames";

import {useEdits} from "contexts/edits";
import {useSetting} from "contexts/setting";
import {Tags} from "layout/Tags";
import Textarea from "layout/Textarea/Textarea";
import {checkIfIDE} from "data/products/index";

import "./index.css";
import {useLogoUrl} from "hooks/useLogoUrl";

export const WithTags = ({
  id,
  contentStyles = {},
  headerStyles = {},
  titleStyles = {},
  tagsStyles = {},
}) => {
  const {product, type, channel} = useSetting();
  const {editTitles} = useEdits();
  const {titles, subtitles, dates} = useEdits();
  const logoURL = useLogoUrl(id);
  const title = titles[id] || titles.main;
  const logoClass = cn("logo", {ide: checkIfIDE(product.value, type.value)});

  useEffect(() => {
    editTitles(`New\nin`, id);
  }, []);

  return (
    <div className="content" style={contentStyles}>
      <header className="template-header" style={headerStyles}>
        <div className={logoClass}>
          <img src={logoURL} alt="background" />
        </div>
      </header>

      <div>
        <div className="title-wrap" style={titleStyles}>
          <h1 className="title">
            <Textarea id={id} text={title} />
          </h1>
        </div>
        <div style={tagsStyles}>
          <Tags className="tags-offset" />
        </div>
      </div>
    </div>
  );
};
